import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { loadCustomers, shouldLoadCustomers } from 'redux/reducers/customers';

import { sortByMetric } from '../../shared/utils/helpers';
import { RootState } from 'redux/rootReducer';
import { IBreakdownData } from '../BreakdownTable';
import { getDisplayName } from './shared';

export default useStreamingBreakdownData;

/*
 * This hook creates and returns an array of objects
 * with label value pairs based on the active metric
 *
 * @param {Array} breakdowns the breakdowns such as 'Streaming'
 * @param {String} activeMetric which metric value to get.
 * @returns {Array} normalized breakdowns and scale callback
 */
function useStreamingBreakdownData(
  breakdowns: IBreakdownData[],
  activeMetric: string
): any[] | undefined {
  const [breakdownRows, setBreakdownRows] = useState<any[]>();

  const dispatch = useDispatch();

  useEffect(() => {
    if (shouldLoadCustomers()) {
      dispatch(loadCustomers());
    }
  }, [dispatch]);

  const customers = useSelector((state: RootState) => state.customers);

  useEffect(() => {
    if (!breakdowns) return;

    function toRowData(breakdown: IBreakdownData): any {
      return {
        label: getDisplayName(breakdown.breakdown, customers),
        values: breakdown.data?.[0]?.data,
        customerValue: breakdown.breakdown,
      };
    }

    const byActiveMetric = sortByMetric(activeMetric);
    const rows = breakdowns.map(toRowData).sort(byActiveMetric);

    setBreakdownRows(rows);
  }, [breakdowns, activeMetric, customers]);

  return breakdownRows;
}
